export default {
    data() {
        return {
            translations: {
                selectPackage: {
                    en: "Please select your package",
                    el: "Παρακαλώ επιλέξτε το πακέτο σας",
                    it: "Seleziona il tuo pacchetto"
                },
                startNow: {
                    en: "Start Now",
                    el: "Ξεκινήστε τώρα",
                    it: "Inizia ora"
                },
                month: {
                    en: "/ month",
                    el: "/ μήνα",
                    it: "/ mese"
                },
                months: {
                    en: "/ {count} months",
                    el: "/ {count} μήνες",
                    it: "/ {count} mesi"
                },
                year: {
                    en: "/ year",
                    el: "/ έτος",
                    it: "/ anno"
                },
                years: {
                    en: "/ {count} years",
                    el: "/ {count} έτη",
                    it: "/ {count} anni"
                }
            }
        };
    }
};